import axios from 'axios';
// import { getWarehouses, saveWarehouse } from 'services/ErplyAPI/warehouses';

const triposRequest = axios.create({
  baseURL: 'https://localhost.erply.com:9000',
  timeout: 0,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

// export const testConnection = () => {
//   return triposRequest
//     .get('/api/v1/testConnection')
//     .then(
//       response => {
//         return response.statusText;
//       },
//       err => {
//         throw err;
//       },
//     )
//     .catch(e => {
//       throw e;
//     });
// };

export const requestSale = (params) =>
  triposRequest
    .post('/api/v1/payment', { transactionType: '1', ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

export const requestCancel = (params) =>
  triposRequest
    .post('/api/v1/cancel', { transactionType: '1', ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

export const requestReversal = (params) =>
  triposRequest
    .post('/api/v1/reversal', { transactionType: '1', ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

export const requestReturn = (params) =>
  triposRequest
    .post('/api/v1/refund', { transactionType: '1', ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

export const requestGetLanesCloud = (params) =>
  triposRequest
    .get('/cloudapi/v1/lanes', { ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

// TODO implement it should be added to MS first
export const requestGetLanesDirect = () => {};

export const requestPostLane = (params) =>
  triposRequest
    .post('/cloudapi/v1/lanes', { ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

export const requestCloudConnection = (params, laneId) =>
  triposRequest
    .get(`/cloudapi/v1/lanes/${laneId}/connectionstatus`, { ...params })
    .then(
      (r) => r,
      (err) => {
        throw err;
      },
    )
    .catch((e) => {
      throw e;
    });

/* export const getTriposConfig = async (warehouseID, posID) => {
  try {
    const [warehouse] = await getWarehouses({ warehouseID });
    const data = warehouse.attributes.find(
      a => a.attributeName === `tripos-posid-${posID}`,
    ).attributeValue;
    let config = {};
    try {
      config = JSON.parse(data);
    } catch (err) {
      // Default value is fine if it fails to parse
    }
    return config;
  } catch (err) {
    console.error('error:getTriposConfig failed \n', err);
    return {};
  }
};

export const saveTriposConfig = async ({ config, warehouseID, posID }) => {
  try {
    await saveWarehouse({
      warehouseID,
      attributeName0: `tripos-posid-${posID}`,
      attributeType0: 'text',
      attributeValue0: JSON.stringify(config),
    });
  } catch (err) {
    console.error('error:saveTriposConfig failed \n', err);
  }
}; */
